import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const setCookieAccessToken = (accessToken: any) => {
  return cookies.set("access_token", accessToken, {
    sameSite: "strict",
    path: "/",
  });
};

export const getCookieToken = () => {
  return cookies.get("access_token");
};

export const removeCookieToken = () => {
  return cookies.remove("access_token", { sameSite: "strict", path: "/" });
};
